import { Button, Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import translation from "../../i18n/i18.json";
import { AuthenticationResult, PublicClientApplication } from "@azure/msal-browser";
import { authConfig } from "../../utils/AuthConfig";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../reducers";
import { UserLoginState } from "../../reducers/LoginReducer";
import { Common } from "../../utils/Common";
import { useHistory } from "react-router-dom";
import { AuthenticationService } from "../../services/AuthenticationService";
import loginStyles from "./Login.css";
import AllActions from "../../actions";
import AlertDialog from '../../components/AlertDialog/AlertDialog';
// import {loginlogo} from '../../asset';

const msaObj = new PublicClientApplication(authConfig);

export default function Login() {
  const loginUser = useSelector<RootState, UserLoginState>(
    (state) => state.loginDetails
  );
  const classes = loginStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const continueLogin = (loginResponse: AuthenticationResult, sapSystem: string) => {
    AuthenticationService.getUserProfile(
      loginResponse.idToken!,
      sapSystem,
      loginResponse.account?.username!,
      function (userProfileData: UserLoginState) {
        if (userProfileData && Object.getOwnPropertyNames(userProfileData).length > 0) {
          Common.setLoginUserData(userProfileData);
          Common.setSapSystem(sapSystem);
          dispatch({
            type: "USER_AUTH_SUCCESS",
            payload: userProfileData,
          });
          history.push("/");
        }
      },
      function (error: Error) {}
    );
  }

  const login = async () => {
    msaObj
      .loginPopup({
        scopes: authConfig.scopes,
        prompt: "select_account",
      })
      .then((loginResponse) => {
        console.log("id_token got at: " + new Date().toString());
        // In case multiple accounts exist, you can select
        const currentAccounts = msaObj.getAllAccounts();
        console.log(loginResponse);

        dispatch(
          AllActions.alertDialogActions.openAlertDialog(
            translation.login_sap_system_title_text,
            translation.login_sap_system_msg_text,
            translation.login_sap_system_s4_btn,
            function () {
              dispatch(AllActions.alertDialogActions.closeAlertDialog());
              continueLogin(loginResponse, "S4");
            },
            translation.login_sap_system_ecc_btn,
            function () {
              dispatch(AllActions.alertDialogActions.closeAlertDialog());
              continueLogin(loginResponse, "ECC");
            },
            "green",
            "green"
          )
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSignIn = () => {
    login();
  };

  return (
    <div className={classes.logInPage}>
      <div className={classes.signInWrapper}>
        <Grid container component="main" className={classes.root}>
          <div className={classes.loginContentWrapper}>
            <div className={classes.logoWrapper}>
              <div className={classes.loginPageLogo} />
            </div>

            <div className={classes.loginDataRowOne}>
              <span className={classes.TxtOne}>Hello!</span>
              <span className={classes.TxtTwo}>
                Welcome to <b>Vendor Onboarding!</b>
              </span>
            </div>
            <div className={classes.loginBtn}>
              <Button onClick={handleSignIn}>
                {translation.login_btn_text}
              </Button>
            </div>
          </div>
        </Grid>
      </div>
      <AlertDialog></AlertDialog>
    </div>
  );
}
